import {Injectable, signal} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Params} from '@angular/router';
import {CommonTableData} from '@lib-ui/common-table/models/common-table-data.class';
import {MessageService} from '@lib-services/message.service';
import {IProject, IProjectTableData} from '@lib-typing/project.interface';
import {ProjectService} from '@lib-services/project.service';
import {ICommonTableConfig, ICommonTableService} from '@lib-ui/common-table/models/common-table.interface';
import {IPaginatedResponse} from '@lib-typing/response.interface';

@Injectable({
    providedIn: 'root',
})
export class ProjectTableService implements ICommonTableService<IProjectTableData> {
    public tableData$: BehaviorSubject<CommonTableData<IProjectTableData>> = new BehaviorSubject<CommonTableData<IProjectTableData>>(new CommonTableData());
    defaultFilterParams = {
        sortBy: 'createdAt:DESC',
    };
    private readonly commonTableData = new CommonTableData();
    loading = signal<boolean>(false);

    constructor(private projectService: ProjectService, private messageService: MessageService) {}

    updateData(config: ICommonTableConfig): void {
        this.loading.set(true);
        this.projectService
            .getList(this.createSearchParams(config))
            .subscribe({
                next: response => {
                    this.tableData$.next(new CommonTableData(this.transformData(response)));
                },
                error: () => this.messageService.errorMessage('Ошибка загрузки списка проектов'),
            })
            .add(() => this.loading.set(false));
    }

    createSearchParams(config: ICommonTableConfig): Params {
        this.commonTableData.data.length = 0;
        const { pageIndex, itemsPerPage } = config.paginatorConfig;
        const { filters } = config;

        let searchParams: Params = {
            ...this.defaultFilterParams,
            limit: itemsPerPage.toString(),
        };

        if (pageIndex) {
            searchParams = {
                ...searchParams,
                page: pageIndex.toString(),
            };
        }

        if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
                if (value) {
                    let filterValue;

                    switch (key) {
                    default:
                        filterValue = `${value}`;
                    }
                    searchParams = {
                        ...searchParams,
                        [`filter.${key}`]: filterValue,
                    };
                }
            });
        }

        return searchParams;
    }

    transformData(response: IPaginatedResponse<IProject>): IPaginatedResponse<IProjectTableData> {
        const transformedData = response.data.map(project => {
            return {
                id: project.id,
                createdAt: project.createdAt,
                updatedAt: project.updatedAt,
                name: project.name,
                companyName: project.company.name
            } as IProjectTableData;

        });
        // Return a new response object with transformed data
        return {
            ...response,
            data: transformedData
        };
    }
}
